// Barrel export for How To Screen Record getting started step images
export { default as step1 } from './setUpRecordingStudio.png';
export { default as step2 } from './startRecording.png';
export { default as step3 } from './repurposeAndShare.png';
